import { useWindowDimensions } from 'react-native';

import LightRatingBottomSheet from '@/components/bottomSheets/LightRatingBottomSheet';
import { useBottomSheet } from '@/contexts/bottomSheetContext';

const useOnLightRatingPress = () => {
  const { dispatch } = useBottomSheet();
  const { height } = useWindowDimensions();

  const onLightRatingPress = ({ name, lightRating }: { name: string | undefined; lightRating: number | null }) => {
    dispatch({
      type: 'SET_BOTTOMSHEET',
      setHeight: height * 0.5 < 525 ? 525 : height * 0.5,
      setContent: <LightRatingBottomSheet churchName={name ?? ''} lightRatingValue={lightRating ?? 0} />,
      setVisible: true
    });
  };

  return { onLightRatingPress };
};

export default useOnLightRatingPress;
